/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type STORY_MODE = "COMMENTS" | "QA" | "RATINGS_AND_REVIEWS" | "%future added value";
export type AllCommentsTabContainer_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly closedAt: string | null;
    readonly settings: {
        readonly live: {
            readonly enabled: boolean;
        };
        readonly mode: STORY_MODE;
    };
    readonly commentCounts: {
        readonly totalPublished: number;
    };
    readonly comments: {
        readonly viewNewEdges: ReadonlyArray<{
            readonly cursor: unknown;
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_comment">;
            };
        }> | null;
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_comment">;
            };
        }>;
    };
    readonly " $fragmentRefs": FragmentRefs<"PostCommentFormContainer_story" | "CreateCommentReplyMutation_story" | "CreateCommentMutation_story" | "ViewersWatchingContainer_story" | "AllCommentsTabCommentContainer_story">;
    readonly " $refType": "AllCommentsTabContainer_story";
};
export type AllCommentsTabContainer_story$data = AllCommentsTabContainer_story;
export type AllCommentsTabContainer_story$key = {
    readonly " $data"?: AllCommentsTabContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainer_story">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "args": null,
        "kind": "FragmentSpread",
        "name": "AllCommentsTabCommentContainer_comment"
    } as any), v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 20,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            },
            {
                "defaultValue": "CREATED_AT_DESC",
                "kind": "LocalArgument",
                "name": "orderBy"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "ratingFilter"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "tag"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "forward",
                    "path": [
                        "comments"
                    ]
                }
            ]
        },
        "name": "AllCommentsTabContainer_story",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isClosed",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "closedAt",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "StorySettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "LiveConfiguration",
                        "kind": "LinkedField",
                        "name": "live",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "enabled",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mode",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "CommentCounts",
                "kind": "LinkedField",
                "name": "commentCounts",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalPublished",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": "comments",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "orderBy",
                        "variableName": "orderBy"
                    },
                    {
                        "kind": "Variable",
                        "name": "rating",
                        "variableName": "ratingFilter"
                    },
                    {
                        "kind": "Variable",
                        "name": "tag",
                        "variableName": "tag"
                    }
                ],
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "__Stream_comments_connection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                    },
                                    (v1 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            (v2 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CommentEdge",
                                "kind": "LinkedField",
                                "name": "viewNewEdges",
                                "plural": true,
                                "selections": [
                                    (v2 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Comment",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v1 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ]
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PostCommentFormContainer_story"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreateCommentReplyMutation_story"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreateCommentMutation_story"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ViewersWatchingContainer_story"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AllCommentsTabCommentContainer_story"
            }
        ],
        "type": "Story",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'dd07995f11d7d4ebcef6c0eac17d16f8';
export default node;
